import { TransactionFlow } from './../../enums/transaction-flow.enum';
import { TransactionModule } from './../../enums/transaction-module.enum';
import { TransactionStatus } from './../../enums/transaction-status.enum';
import { TransactionItem } from './../../models/transaction-item.model';
import { Transaction } from './../../models/transaction.model';

export const accountTransactionImage = (
  transaction: Transaction | TransactionItem | null
): string | null => {
  if (transaction) {
    switch (transaction.status) {
      case TransactionStatus.Signed:
        switch (transaction.module) {
          case TransactionModule.Bank:
          case TransactionModule.Other:
          case null:
            return 'assets/images/transaction/obrada.svg';
          case TransactionModule.CardLegal:
          case TransactionModule.CardPersonal:
            return 'assets/images/transaction/kartica_autorizacija.svg';
        }
        break;
      case TransactionStatus.Pending:
        return 'assets/images/transaction/najava.svg';
      case TransactionStatus.Rejected:
        return 'assets/images/transaction/odbijeni_grey.svg';
      case TransactionStatus.Completed:
        switch (transaction.flow) {
          case TransactionFlow.Incoming:
            switch (transaction.module) {
              case TransactionModule.Bank:
              case TransactionModule.Other:
              case null:
                return 'assets/images/transaction/uplate.svg';
              case TransactionModule.CardLegal:
              case TransactionModule.CardPersonal:
                return 'assets/images/transaction/kartica_uplata.svg';
            }
            break;
          case TransactionFlow.Outgoing:
            switch (transaction.module) {
              case TransactionModule.Bank:
              case TransactionModule.Other:
              case null:
                return 'assets/images/transaction/isplate.svg';
              case TransactionModule.CardLegal:
              case TransactionModule.CardPersonal:
                return 'assets/images/transaction/kartica_isplata.svg';
            }
        }
        break;
      default:
        return null;
    }
  }
  return null;
};
